
import React, { Component } from 'react';
import ThirdCom from '../ThirdCom';

/**
 * 打印次数
 */
class PrintLimitModal extends Component {

    state = { showLimitModal: this.props.showLimitModal }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let { showLimitModal } = nextProps;
        if (showLimitModal !== this.state.showLimitModal) {
            this.setState({ showLimitModal: showLimitModal });
        }
    }

    closePrintLimitModalEvent = () => {
        let { closePrintLimitModal, onCloseorHideModal } = this.props;
        if (typeof closePrintLimitModal === "function") {
            closePrintLimitModal();
        }
        if (typeof onCloseorHideModal === 'function') {
            onCloseorHideModal('showLimitModal');
        }
        this.setState({ showLimitModal: false });
    }

    render() {
        let { showLimitModal } = this.state;
        return <ThirdCom
            {...this.props}
            closePrintLimitModal={this.closePrintLimitModalEvent}
            showThirdComponent={showLimitModal}
            componentNameSpace="uap/common/components/PrintLimitQueryByPlug/index"
            componentPath="../../../../uap/common/components/PrintLimitQueryByPlug/index.js"
        />;
    }
}

export default PrintLimitModal;
